import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CardLayout from '@/components/Layout/CardLayout';
import Button from '@/components/ui/Button';
import PrimaryInput from '@/components/ui/PrimaryInput';
import { IDeleteResponse } from '@/interfaces/common.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Modal } from 'reactstrap';
import { ITableData } from './AssetsCategory';
interface IAddAssetsCategoryModalProps {
  isOpen: boolean;
  editData: ITableData | null;
  onClose: () => void;
  getAssetsCategory: () => void;
}
const AddAssetsCategoryModal = ({
  isOpen,
  editData,
  onClose,
  getAssetsCategory,
}: IAddAssetsCategoryModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    clearErrors,
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<ITableData>();
  console.log(editData);
  const onSubmit: SubmitHandler<ITableData> = async (data) => {
    console.log(editData);
    const postData = {
      ...data,
      status: editData ? editData?.status : true,
    };
    try {
      setIsLoading(true);
      const response: IDeleteResponse = await callApi(
        editData
          ? API_URL +
              API_ENDPOINT.addAssetsCategory +
              '?assetCategoryId=' +
              editData?.id
          : API_URL + API_ENDPOINT.addAssetsCategory,
        {
          method: 'POST',
          data: postData,
        },
      );
      if (response?.status) {
        showToastNotification('success', response?.message);
        onClose();
        getAssetsCategory();
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (editData) {
      console.log(editData);
      reset({
        name: editData?.name,
        description: editData?.description,
      });
    }
  }, [editData]);
  return (
    <Modal
      className="modal-dialog modal-dialog-centered modal-md"
      isOpen={isOpen}
    >
      <div className="modal-content shadow-lg">
        <div className="modal-header p-4">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="addHolidayModalLabel"
          >
            {editData ? 'Edit' : 'Add'} Asset category
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              clearErrors();
              onClose();
              reset();
            }}
          />
        </div>
        <div className="modal-body p-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <CardLayout cardStyle="shadow-none mb-0">
              <div className="col-12">
                <div className="form-group mb-3">
                  <PrimaryInput
                    label="Category Name"
                    type="text"
                    id="category"
                    placeholder="Enter category name"
                    required={true}
                    {...register('name', {
                      ...errorTypes.required(),
                      ...errorTypes.name,
                    })}
                    errors={errors?.name?.message}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="description" className="form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                    rows={3}
                    id="description"
                    placeholder="Enter Description here"
                    {...register('description', {
                      required: 'Description is required',
                    })}
                  />
                  {errors.description && (
                    <div className="form-text text-danger">
                      {errors.description.message}
                    </div>
                  )}
                </div>
              </div>
            </CardLayout>
            <div className="modal-footer p-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  clearErrors();
                  onClose();
                  reset();
                }}
              >
                Cancel
              </button>
              <Button
                type="submit"
                className="btn btn-primary"
                isLoading={isLoading}
              >
                {editData ? 'Edit Category' : 'Add Category'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export default AddAssetsCategoryModal;
